import * as microsoftTeams from '@microsoft/teams-js';

export interface ICareerHubAppconfig {
  clientId: string;
  tenant?: string;
  redirectUri: string;
  resource?: string;
}

export enum HostType {
  M365App = 'M365App',
  Standalone = 'Standalone',
}

export const CareerHubIFrameHostName = 'careerhub-host-iframe';

export interface CareerHubSDKContext extends microsoftTeams.app.Context {}

// TODO stop using deprecated types
export type AuthenticateParameters = microsoftTeams.authentication.AuthenticateParameters;
export type AuthTokenRequest = microsoftTeams.authentication.AuthTokenRequest;
export type UserRequest = microsoftTeams.authentication.UserRequest;

export type UserProfile = microsoftTeams.authentication.UserProfile;

export type TaskInfo = microsoftTeams.TaskInfo;

export type IAppWindow = microsoftTeams.IAppWindow;

export type ISdkResponse = microsoftTeams.dialog.ISdkResponse;

export type PostMessageChannel = microsoftTeams.dialog.PostMessageChannel;

export type DialogSubmitHandler = (result: ISdkResponse) => void;

export import TaskModuleDimension = microsoftTeams.TaskModuleDimension;
import { UrlDialogInfo } from '@microsoft/teams-js';

export interface IAuthentication {
  getAuthToken(authTokenRequest: AuthTokenRequest): void;
  authenticate(authenticateParameters?: AuthenticateParameters): void;
  getUser(userRequest: UserRequest): void;
  notifySuccess(result?: string, callbackUrl?: string): void;
  notifyFailure(_reason?: string, _callbackUrl?: string): void;
  logout?(): void;
}

export interface ICareerHubSdk {
  authentication: IAuthentication;
  app: {
    initialize(validMessageOrigins?: string[]): Promise<void>;
    getContext(): Promise<CareerHubSDKContext>;
    registerOnThemeChangeHandler(handler: (theme: string) => void): void;
    openLink(link: string): Promise<void>;
  };
  dialog: {
    url: {
      open(
        urlDialogInfo: UrlDialogInfo,
        submitHandler?: DialogSubmitHandler,
        messageFromChildHandler?: PostMessageChannel
      ): void;
      submit(result?: string | object, appIds?: string | string[]): void;
    };
  };
}
